// AutoMapper
import { AutoMap } from '@nartc/automapper';

// ViewModel
import { PersonalInformationVm } from 'app/_mapper/personal-information.vm';
import { CountryVm } from 'app/_mapper/country.vm';
import { CaseTypeVm } from 'app/_mapper/casetype.vm';
import { CauseVm } from 'app/_mapper/cause.vm';
import { ClientVm } from 'app/_mapper/client.vm';
import { SelectedtravelPolicyVm } from 'app/_mapper/selectedtravelpolicy.vm';
import { PiaCheckResultVm } from 'app/_mapper/piacheckresult.vm';
import { VecozoCheckResultVM } from 'app/_mapper/vecozocheckresult.vm';
import { SelectedhealthPolicyVm } from 'app/_mapper/selectedhealthpolicy.vm';
import { CalamityVm } from './calamityvm';

export class PolicyVm {
  @AutoMap(()=> CalamityVm)camality: CalamityVm;
  @AutoMap(() => CauseVm) cause: CauseVm;
  @AutoMap(() => ClientVm) client: ClientVm;
  @AutoMap(() => CountryVm) country: CountryVm;
  @AutoMap() dossierNbr: string;
  @AutoMap() isowncost: boolean;
  @AutoMap() location: string;
  @AutoMap(() => PersonalInformationVm) personalInformations: PersonalInformationVm;
  @AutoMap(() => PiaCheckResultVm) piaCheckResult: PiaCheckResultVm[];
  @AutoMap(() => SelectedhealthPolicyVm) selectedhealthPolicies: SelectedhealthPolicyVm[];
  @AutoMap(() => SelectedtravelPolicyVm) selectedtravelPolicies: SelectedtravelPolicyVm[];
  @AutoMap() travelInsuranceValidity: boolean;
  @AutoMap() vecozoCheckResult: VecozoCheckResultVM[];
}